import React from 'react';

const Snackbar = ({ message, visible, type }) => {
    if (!visible) return null;

    let bgColor = 'bg-blue-500';
    if (type === 'success') bgColor = 'bg-green-500';
    if (type === 'warning') bgColor = 'bg-yellow-500';
    if (type === 'error') bgColor = 'bg-red-500';

    return (
        <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 ${bgColor} text-white px-6 py-3 rounded-full shadow-lg z-50 transition-transform duration-300 ease-out animate-slide-up`}>
            {message}
        </div>
    );
};

export default Snackbar;
